<template>
  <div class="child-wrapper">
    <h3>{{ child.label }}</h3>
    <div class="tags">
      <div v-bind:key="tag" v-for="tag in child.tags" class="tag" :class="tag">
        {{ getTagLetter(tag) }}
      </div>
    </div>
    <img
      v-if="child.children && !open"
      class="circle-icon plus-circle-icon"
      :src="plusCircleSrc"
      alt="plus-circle"
    />
    <img
      v-if="child.children && open"
      class="circle-icon minus-circle-icon"
      :src="minusCircleSrc"
      alt="minus-circle"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Children, Children2 } from "@/types/jsonTypes";
import plusCircleSrc from "@/assets/plus-circle.svg";
import minusCircleSrc from "@/assets/minus-circle.svg";

export default defineComponent({
  name: "ChildWrapper",
  props: {
    child: {
      type: Object as PropType<Children | Children2>,
      required: true,
    },
    open: {
      type: Boolean,
    },
  },
  data() {
    return {
      plusCircleSrc,
      minusCircleSrc,
    };
  },
  methods: {
    getTagLetter(tag: string): string {
      console.log(tag);
      if (tag === "tilaaja") return "T";
      if (tag === "toimittaja") return "L";
      return "";
    },
  },
});
</script>

<style scoped lang="scss">
.child-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  h3 {
    font-family: "Raleway", sans-serif;
    font-size: 1.25rem;
    text-align: center;
  }

  .tags {
    position: absolute;
    left: 0.75rem;
    bottom: 0.5rem;
    display: flex;

    .tag {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin-right: 0.25rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #000;
      font-weight: bold;

      &.tilaaja {
        background: #80ffd4;
      }
      &.toimittaja {
        background: #cc5279;
      }
      &.kuten_sovittu {
        background: #52b2cc;
      }
    }
  }

  .circle-icon {
    position: absolute;
    bottom: 0.5rem;
    right: 0.75rem;
  }
}
</style>
